/*
 * @Author: Risker-C
 * @Date: 2021-09-13 16:28:00
 * @LastEditTime: 2021-09-13 17:32:43
 * @LastEditors: Risker-C
 * @Description: 
 * @FilePath: \yh-wms\src\views\content\contentService.ts
 */

import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { ids } from "../projectCase/caseTypes";
import { IContentDetail } from "./contentTypes";

export interface UpFileToken { uptoken: string;domain: string}
export interface COSUpFileToken {
    requestId: string;
    startTime: number;
    expiration: string;
    expiredTime: number;
    credentials: {
        sessionToken: string;
        tmpSecretId: string;
        tmpSecretKey: string;
    }
}
class ContentService {
    async page(searchVo: IContentDetail) {
        const apiUrl = "/web/content/search_page";
        return await httpRequest.post<IPage<IContentDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/web/content/search_one/${id}`;
        return await httpRequest.get<IContentDetail>(apiUrl);
    }
    async insert(insertVo: IContentDetail) {
        const apiUrl = `/web/content/insert`;
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IContentDetail) {
        const apiUrl = `/web/content/update`;
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async delete(ids: ids) {
        const apiUrl = `/web/content/delete`;
        return await httpRequest.post<boolean>(apiUrl,ids);
    }
    // async getUpFileToken() {
    //     const apiUrl = `http://localhost:9000/api/uptoken`;
    //     return await httpRequest.get<UpFileToken>(apiUrl);
    // }
    async getUpFileToken() {
        // const apiUrl = `http://49.232.218.5:5050/cos/sdk`;
        const apiUrl = `http://www.yunhaogroup.com/cos/sdk`;

       
        return await httpRequest.get<COSUpFileToken>(apiUrl);
    }
}
export const contentService = new ContentService();
